import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showModal, hideModal } from 'store/actions/modal.actions';
import { CloseInCircle } from 'components';
// modals
import { ConnectModal } from './ConnectModal';
import { DeclineModal } from './DeclineModal';
import { InfoModal } from './InfoModal';
import { GalleryModal } from './GalleryModal';
import { ConfirmModal } from './ConfirmModal';
import { ModalWithChild } from './ModalWithChild';
import { LinkModal } from './LinkModal';
import { UnlinkModal } from './UnlinkModal';
import { BlockedModal } from './BlockedModal';
import { MobileMenu } from './MobileMenu';
import { RequestModal } from './RequestModal';
import { ApproveApplicationModal } from './ApproveApplicationModal';
import { MODAL_TYPES } from './constants';

import './modal.scss';

@connect(
  ({ modalState }) => ({
    modalState,
  }),
  (dispatch) => ({
    showModal: bindActionCreators(showModal, dispatch),
    hideModal: bindActionCreators(hideModal, dispatch),
  }),
)
class Modals extends React.PureComponent {
  static propTypes = {
    modalState: PropTypes.object,
    showModal: PropTypes.func,
    hideModal: PropTypes.func,
  };

  static defaultProps = {
    modalState: {},
    showModal: Function.prototype,
    hideModal: Function.prototype,
  };

  state = {
    Node: null,
  };

  static getDerivedStateFromProps(props) {
    const { modalState = {} } = props;
    const { modal } = modalState;

    if (!modal) {
      return null;
    }

    const newStateProps = {};

    switch (modal) {
      case MODAL_TYPES.CONNECT:
        newStateProps.Node = ConnectModal;
        break;
      case MODAL_TYPES.REQUEST:
        newStateProps.Node = RequestModal;
        break;
      case MODAL_TYPES.DECLINE:
        newStateProps.Node = DeclineModal;
        break;
      case MODAL_TYPES.INFO:
        newStateProps.Node = InfoModal;
        break;
      case MODAL_TYPES.GALLERY:
        newStateProps.Node = GalleryModal;
        break;
      case MODAL_TYPES.CONFIRM:
        newStateProps.Node = ConfirmModal;
        break;
      case MODAL_TYPES.WITH_CHILD:
        newStateProps.Node = ModalWithChild;
        break;
      case MODAL_TYPES.LINK:
        newStateProps.Node = LinkModal;
        break;
      case MODAL_TYPES.UNLINK:
        newStateProps.Node = UnlinkModal;
        break;
      case MODAL_TYPES.BLOCKED:
        newStateProps.Node = BlockedModal;
        break;
      case MODAL_TYPES.MOBILE_MENU:
        newStateProps.Node = MobileMenu;
        break;
      case MODAL_TYPES.APPROVE_APPLICATION:
        newStateProps.Node = ApproveApplicationModal;
        break;
      default:
        newStateProps.Node = null;
    }

    return newStateProps;
  }

  render() {
    const { modalState } = this.props;
    const { options: { withCross } = {} } = modalState;
    const { Node } = this.state;

    if (!Boolean(Node)) return null;

    return (
      <ReactModal
        isOpen={modalState.isShow}
        className="modal__window"
        overlayClassName={`modal__overlay ${
          modalState?.isShow && modalState.modal === 'mobile-menu'
            ? 'modal__overlay_left modal__overlay_top'
            : ''
        }`}
        shouldCloseOnOverlayClick={!withCross}
        onRequestClose={this.props.hideModal}
        ariaHideApp={false}
        onAfterOpen={() => {
          document.querySelector('body').overflow = 'hidden';
        }}
      >
        <Node
          showModal={this.props.showModal}
          hideModal={this.props.hideModal}
          options={modalState.options}
        />
        {modalState.options && modalState.options.withCross && (
          <CloseInCircle
            fill="#fff"
            className="modal__cross"
            onClick={this.props.hideModal}
          />
        )}
      </ReactModal>
    );
  }
}

export default Modals;
